import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { NAV, SITE } from "../../content/site";
import { useContent } from "../../context/ContentContext";

export const Footer = () => {
  const year = new Date().getFullYear();
  const { content } = useContent();
  const contact = content.contact;
  const services = content.services || [];
  return (
    <footer className="bg-navy text-cream pt-20 pb-10" data-testid="site-footer">
      <div className="container-site">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12 pb-14 border-b border-cream/10">
          <div className="md:col-span-5">
            <div className="bg-cream inline-block p-3 rounded-sm mb-6">
              <img
                src={SITE.logoUrl}
                alt="Fourbees Consultancy"
                className="h-12 w-auto mix-blend-multiply"
              />
            </div>
            <p className="font-body text-cream/70 leading-relaxed max-w-md mb-7">
              Specialist consultancy for the UK doorstep dairy industry.
              Over 15 years of hands-on experience helping independent dairies
              and small businesses operate better and grow sustainably.
            </p>
            <div className="space-y-3 text-sm">
              <a
                href={`tel:${contact.phone.replace(/\s/g, "")}`}
                className="flex items-center gap-3 text-cream/80 hover:text-gold transition-colors"
                data-testid="footer-phone"
              >
                <Phone size={14} strokeWidth={2} />
                {contact.phone}
              </a>
              <a
                href={`mailto:${contact.email}`}
                className="flex items-center gap-3 text-cream/80 hover:text-gold transition-colors break-all"
                data-testid="footer-email"
              >
                <Mail size={14} strokeWidth={2} />
                {contact.email}
              </a>
              <div className="flex items-center gap-3 text-cream/80">
                <MapPin size={14} strokeWidth={2} />
                {contact.location}
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-body text-xs font-semibold uppercase tracking-[0.22em] text-gold mb-5">
              Navigate
            </h4>
            <ul className="space-y-3">
              {NAV.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-sm text-cream/70 hover:text-gold transition-colors"
                    data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-cream/70 hover:text-gold transition-colors"
                  data-testid="footer-nav-privacy"
                >
                  Privacy
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-body text-xs font-semibold uppercase tracking-[0.22em] text-gold mb-5">
              Services
            </h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link
                    to="/services"
                    className="text-sm text-cream/70 hover:text-gold transition-colors"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <p className="text-xs text-cream/50">
            &copy; {year} {SITE.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-3">
            <a
              href={contact.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="w-10 h-10 border border-cream/20 rounded-sm flex items-center justify-center text-cream/70 hover:bg-gold hover:text-navy hover:border-gold transition-colors"
              data-testid="footer-linkedin"
            >
              <Linkedin size={16} strokeWidth={2} />
            </a>
            <a
              href={`mailto:${contact.email}`}
              aria-label="Email"
              className="w-10 h-10 border border-cream/20 rounded-sm flex items-center justify-center text-cream/70 hover:bg-gold hover:text-navy hover:border-gold transition-colors"
              data-testid="footer-email-icon"
            >
              <Mail size={16} strokeWidth={2} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
